<template>
  <div>
    <div class="tabs flex  pt-8 mb-2 gap-6">
      <button class="flex-1 flex items-center " v-for="(tab, index) in tabs" :key="index" :class="{
        active: selectedIndex === index || completedSteps.includes(index)
      }" @click="selectTab(index)">
        <h1>{{ tab.count }}</h1>

        <span>{{ tab.name }}</span>
        <img :src="tab.widget" alt="" srcset="">
      </button>
    </div>
    <!-- <hr /> -->
    <div class="tab-content mt-4">
      <component :is="selectedComponent" :selectedReuploadTab='selectedReuploadTab'
        @openRegisteredAddress="openRegisteredAddress" @openVerify="openVerify"
        @saveBusinessDetails="saveBusinessDetails"></component>
    </div>

     <SuccessModal :show-modal="showSuccessModal"   @close-modal="showSuccessModal = false"/> 
     <!-- <SuccessModal v-if="showSuccessModal" />  -->
  </div>
</template>

<script>
import ArrowLine from '../../../../../../../../../public/icons/line nav.svg';
import IncorporationDetails from './modules/bs/ic/IncorporationDetails.vue';
import RegisteredAddress from './modules/bs/ra/RegisteredAddress.vue';
import Rify from './modules/bs/Rify.vue';
import SuccessModal from './modals/SuccessModal.vue';



export default {
  components: {
    IncorporationDetails,
    RegisteredAddress,
    Rify,
    SuccessModal 
  },
  props: ['selectedReuploadTab'],

  data() {
    return {
      orgimage: '',
      companyName: '',
      organizationId: '',
      user: {},
      location: {},
      showSuccessModal: false, 
      selectedIndex: 0,
      completedSteps: [],
      incorporationData: {},
      registeredAddressData: {},
      verifyData: {},
      tabs: [
        { count: 1, widget: ArrowLine, name: 'Incorporation Details', component: IncorporationDetails },
        { count: 2, widget: ArrowLine, name: 'Registered Address', component: RegisteredAddress },
        { count: 3, name: 'Verify', component: Rify },
      ],
    };
  },
  mounted() {
    this.findUserDetails();
  },
  computed: {
    payload() {
      return {
        orgId: this.organizationId,
        imageurl: this.orgimage,

        businessInfo: {
          businessName: this.incorporationData?.incorporationName,
          rcNumber: this.incorporationData?.rcNumber,
          address: this.registeredAddressData?.address,
          taxId: this.incorporationData?.tin,
          type: this.incorporationData?.selected
        },

        proofOfAddress: {
          documentUrl: this.verifyData.imageUrl
        },
        taxDocuments: [
          {
            "type": "tid",
            "documentUrl": this.incorporationData?.tid
          }

        ],

        documents: {
          certificateOfRegistration: {
            documentUrl: this.incorporationData?.certificateOfIncorporation,
            status: "pending"
          },

          memorandumAndArticles: {
            documentUrl: this.incorporationData?.memat,
            status: "pending"
          },

          formCAC11: {
            documentUrl: this.incorporationData?.formCAC,
            status: "pending"
          },

          statusReport: {
            documentUrl: this.incorporationData?.statusReport,
            status: "pending"
          },

          regulatoryLicense: {
            type: "NPOST",
            documentUrl: this.incorporationData?.regulatoryLicense
          },

        }
      }
    },

    selectedComponent() {
      return this.tabs[this.selectedIndex].component;
    },
  },



  methods: {
   
    async findUserDetails() {
      try {
        let response = await this.$_findUserDetails();
        this.location = response.data.data.Org.locations[0];
        this.organizationId = response.data.data.Org.id;
        this.companyName = response.data.data.Org.companyname;
        this.orgimage = response.data.data.Org.orgimage;

      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    openRegisteredAddress(kycData) {
      this.incorporationData = kycData; // Store the received data in a local variable
      this.selectedIndex = 1;
    },
   

    openVerify(locationData) {
      this.registeredAddressData = locationData;
      // Store the received data in a local variable            
      if (locationData) {
        const responseData = locationData;
        localStorage.setItem('addressData', JSON.stringify(responseData));
        // this.completedSteps.push(1); // step 2 completed
        if (!this.completedSteps.includes(1)) {
          this.completedSteps.push(1);
        }
        this.selectedIndex = 2;
      }
    },

    saveBusinessDetails(imageUrl) {
      this.verifyData = imageUrl; // Store the received data in a local variable
      this.updateKyc();
    },

    async updateKyc() {
      try {
        let response = await this.$_saveBusinessKycInformation(this.payload);

        if (response.data.success === true) {
          const responseData = response.data;
          localStorage.setItem('kycData', JSON.stringify(responseData));
          // const kyc = response?.data?.data?.org?.companyKYC;                   
          //     if (kyc) {
          //         this.$store.dispatch("saveBusinessDetails", kyc);
          //     }                   
              this.showSuccessModal = !this.showSuccessModal;
          this.generateToast("Your information has been updated!", "success");
          
        }
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },

  },

};
</script>

<style scoped>
.tabs>:nth-child(1),
.tabs>:nth-child(2) {
  justify-content: space-between;
}

.tabs>:nth-child(1)>h1 {
  font-size: 12px;
  font-weight: 700;
  padding: 3% 4% 3% 4%;
  border-radius: 50%;
  background-color: #10233E;
  color: white;
}

.tabs>:nth-child(1)>span {
  font-weight: 600;
  font-weight: 14px;
  color: #14171F;
}

.tabs>:nth-child(3) {
  gap: 17%;
}

.tabs>:nth-child(2)>span,
.tabs>:nth-child(3)>span {
  font-weight: 600;
  font-weight: 14px;
  color: #7A90A7;
}

.tabs>:nth-child(2)>h1,
.tabs>:nth-child(3)>h1 {
  font-size: 12px;
  font-weight: 700;
  padding: 2% 3% 2% 3%;
  border-radius: 50%;
  background-color: #EBF2FA;
  color: #667499;
}

.tabs .active>span {
  font-weight: 600;
  font-weight: 14px;
  color: #14171F;
}

.tabs .active>h1 {
  font-size: 12px;
  font-weight: 700;
  padding: 3% 4% 3% 4%;
  border-radius: 50%;
  background-color: #10233E;
  color: white;
}
</style>
